import React, { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";

import { isApiEnvSwitchEnabled } from "../../api/apiEnv";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { fetchInquiries } from "../../store/slices/inquiriesSlice";

type MenuItem = {
  label: string;
  to?: string;
};

const menuItems: MenuItem[] = [
  { label: "회원관리", to: "/admin/members" },
  { label: "지점관리", to: "/admin/branches" },
  { label: "사업주 인증", to: "/admin/owner-certifications" },
  { label: "공지사항", to: "/admin/notices" },
  { label: "FAQ", to: "/admin/faqs" },
  { label: "1:1 문의 관리", to: "/admin/inquiries" },
  { label: "약관/개인정보", to: "/admin/policies" },
  { label: "앱 기준정보 설정", to: "/admin/app-basic-settings" },
  { label: "앱 업데이트", to: "/admin/app-update" },
  ...(isApiEnvSwitchEnabled() ? [{ label: "API 환경", to: "/admin/api-env" }] : []),
];

const SideNav = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const pendingCount = useAppSelector((state) => state.inquiries.pendingCount);
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }
    // 사이드바 미답변 뱃지용 — 목록은 덮어쓰지 않음
    dispatch(fetchInquiries({ page: 1, page_size: 1, countsOnly: true }));
  }, [dispatch, isAuthenticated, location.pathname]);

  return (
    <aside className="admin-sidebar">
      {menuItems.map((item) => {
        if (!item.to) {
          return (
            <button className="sidebar-item disabled" key={item.label} type="button" disabled>
              <span>{item.label}</span>
            </button>
          );
        }

        const isSelected = location.pathname.startsWith(item.to);
        const showBadge = item.to === "/admin/inquiries" && pendingCount > 0;

        return (
          <NavLink className={`sidebar-item ${isSelected ? "selected" : ""}`} key={item.to} to={item.to}>
            <span>{item.label}</span>
            {showBadge && <span className="sidebar-badge">{pendingCount > 99 ? "99+" : pendingCount}</span>}
          </NavLink>
        );
      })}
    </aside>
  );
};

export default SideNav;
